module.exports = require("@angular/cdk/table");


//////////////////
// WEBPACK FOOTER
// external "@angular/cdk/table"
// module id = 249
// module chunks = 0